"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Yup = __importStar(require("yup"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const libs_auth_next_1 = require("@hotelplan/libs.auth-next");
const B2BLoginValidationSchema = Yup.object({
    username: Yup.string().required('forms:errors.agentCode.required'),
    password: Yup.string().required('forms:errors.password.required'),
    userCode: Yup.string().notRequired(),
});
const FailureLoginErrorMessage = styled_components_1.default.form(({ theme }) => theme.auth.errorMessage);
const LoginForm = styled_components_1.default.form(({ theme }) => theme.auth.loginForm);
const B2BLoginForm = props => {
    const { hasForgotPasswordLink = true, onLogin = noop_1.default, onForgotPasswordClick = noop_1.default, } = props;
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'auth']);
    const { client } = (0, libs_auth_next_1.useAuthContext)();
    const [error, setError] = (0, react_1.useState)(false);
    const onSubmit = (values, helpers) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const { error: isError } = yield client.b2bLogin(values);
            if (!isError) {
                onLogin(values);
                window.location.href = '/';
            }
            else {
                setError(true);
            }
        }
        catch (e) {
            setError(true);
        }
        finally {
            helpers.resetForm();
        }
    });
    return (react_1.default.createElement(formik_1.Formik, { initialValues: {
            username: '',
            password: '',
            userCode: '',
        }, onSubmit: onSubmit, validationSchema: B2BLoginValidationSchema }, formik => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            error && (react_1.default.createElement(FailureLoginErrorMessage, null, t('auth:login.failure'))),
            react_1.default.createElement(LoginForm, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "username", label: t('forms:agentCode.label'), className: "text-input", showErrorMessage: true }),
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "password", type: "password", autoComplete: "current-password", label: t('forms:password.label'), className: "text-input", showErrorMessage: true }),
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { name: "userCode", label: t('forms:userCode.label'), className: "text-input" }),
                react_1.default.createElement(components_common_buttons_1.Button, { disabled: formik.isSubmitting, className: "login-form-submit", type: "submit" }, t('forms:login.button')),
                hasForgotPasswordLink && (react_1.default.createElement(components_common_buttons_1.Button, { variant: "linkBtn", className: "login-form-forgot-button", onClick: onForgotPasswordClick }, t('forms:forgotPassword'))))));
    }));
};
exports.default = B2BLoginForm;
//# sourceMappingURL=B2BLoginForm.js.map